<template>
  <div>
    <div class="titlebar h-16 bg-gray-300 flex justify-between fixed top-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/home.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        Menu
      </div>
      <div class="flex justify-center items-center mr-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/close.svg" alt="">
      </div>
    </div>
    <div class="h-16"></div>

    <div class="max-w-xl mx-auto mt-8">

      <div class="bg-gray-200 p-8 rounded-lg shadow-xl">
        <div class="pl-4 pt-4">
          Logged in as:
        </div>
        <div class="p-3 mt-0 flex flex-row items-center justify-center flex-row">
          <div>
            <!-- <img src="../ics/avatar.svg" alt="avatar"> -->
          </div>
          <div class="ml-3" v-if="getMe()">
            <div>
              @{{ getMe().user.username }}
            </div>

            <div @click="logoutMe()">
              Logout
            </div>
          </div>
        </div>
        <div class="pl-4 pt-4">
          Swtich Accounts
        </div>
        <div class="pl-4 pt-4">
          <li :key="profile.user._id" v-for="profile in accounts()" class=" pb-4 text-bold" :class="{ 'text-blue-600': profile.jwt === (getMe() && getMe().jwt) }" @click="changeProfile({ profile })">{{ profile.user.username }}</li>
          <div>
            <div @click="$router.push('/login')">
              + Accounts
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- <div class="h-16"></div>
    <div class="bottombar h-16 bg-gray-300 flex justify-between fixed bottom-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img src="../ics/plus.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        <img src="../ics/bell.svg" alt="">
      </div>
      <div class="flex justify-center items-center mr-5">
        <img src="../ics/reload.svg" alt="">
      </div>
    </div> -->
  </div>
</template>

<script>
import * as API from '../../api/api.js'

export default {
  components: {
    // LeftMenu: require('../uis/LeftMenu.vue').default
  },
  methods: {
    getMe () {
      return API.getCurrentUser()
    },
    accounts () {
      return API.getLoggedInList()
    },
    reload () {
      this.$forceUpdate()
    },
    changeProfile ({ profile }) {
      API.changeProfile({ profile })
      this.reload()
    },
    logoutMe () {
      if (window.confirm('logout?')) {
        API.forgetMe({ profile: this.getMe() })
        this.reload()
        if (this.accounts().length === 0) {
          this.$router.push('/')
        }
      }
    }
  }
}
</script>

<style>

</style>
